import { KpiDetails, KpiValue, DisplayType, ComparisonPeriod, IndicatorType } from 'domain/kpis/types';

import config from 'config';
import { CompanyId } from 'urls';

import ApiBase from '../ApiBase';

const KPI_API_PATH = config.COMPANIES_API_URL + '/companies';

const api = ApiBase();

interface KpiDisplayConfig {
  displayType: DisplayType;
  trendIndicator: 'Up' | 'Down';
  showXAxis?: boolean;
  showYAxis?: boolean;
  comparisonEnabled?: boolean;
  comparisonPeriod?: ComparisonPeriod;
  visibility?: 'Public' | 'Private';
  maxDataPoints?: number;
}

interface CreateKpi {
  name: string;
  description?: string;
  unitOfMeasure?: string;
  initialDisplays?: KpiDisplayConfig[];
}

interface EditKpi {
  name?: string;
  description?: string;
  unitOfMeasure?: string;
  sortOrder?: number;
}

export interface AddKpiValue {
  add: {
    kpiId: string;
    value: number;
    date: string;
  };
}

interface DeleteKpiValue {
  delete: {
    kpiId: string;
    date: string;
  };
}

export type KpiId = string;
export type AddOrDeleteKpiValue = AddKpiValue | DeleteKpiValue;

interface UpdateKpiDisplay {
  displayType?: DisplayType;
  trendIndicator?: IndicatorType;
  displayOrder?: number;
  sortOrder?: number;
  showXAxis?: boolean;
  showYAxis?: boolean;
  comparisonEnabled?: boolean;
  comparisonPeriod?: ComparisonPeriod;
  visibility?: 'Public' | 'Private';
  maxDataPoints?: number;
}

export default {
  kpi: {
    archive: (companyId: CompanyId, kpiId: string) =>
      api.patch(`${KPI_API_PATH}/${companyId}/kpis/${kpiId}`, { isArchived: true }),
    unArchive: (companyId: CompanyId, kpiId: string) =>
      api.patch(`${KPI_API_PATH}/${companyId}/kpis/${kpiId}`, { isArchived: false }),
    // Backend auto-creates default NumberIndicator display when KPI is created
    new: (companyId: CompanyId, kpi: CreateKpi) => api.post<KpiDetails>(`${KPI_API_PATH}/${companyId}/kpis`, kpi),
    edit: (companyId: CompanyId, kpiId: string, kpi: EditKpi) =>
      api.patch<KpiDetails>(`${KPI_API_PATH}/${companyId}/kpis/${kpiId}`, kpi),
    list: (companyId: CompanyId) => `${KPI_API_PATH}/${companyId}/kpis`,
    updateValues: (companyId: CompanyId, updates: AddOrDeleteKpiValue[]) =>
      api.post<Record<KpiId, KpiValue[]>>(`${KPI_API_PATH}/${companyId}/kpis/updatevalues`, updates),
  },
  display: {
    update: (companyId: CompanyId, displayId: string, updates: UpdateKpiDisplay) =>
      api.patch(`${KPI_API_PATH}/${companyId}/kpis/displays/${displayId}`, updates),
  },
};
